import {useTranslation} from "react-i18next";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {swallowException} from "../../utils/appUtils";
import {getResourceErrorMessage, isResourceFailed} from "../../utils/resourceUtils";
import {useOrderManagement} from "../../hooks/ordersHooks";
import {OrderStatus} from "../../types/domain/orderStatus";

export interface Props {
    companyId: string;
    orderId: string;
    newStatus: OrderStatus;
    open: boolean;
    onClose: (isSuccessful: boolean) => void;
}

export const OrderChangeStatusDialog: React.FC<Props> = ({companyId, orderId, newStatus, open, onClose}) => {
    const {t} = useTranslation();
    const orderManagement = useOrderManagement();

    const handleSubmit = () => {
        orderManagement.reset();

        orderManagement
            .changeStatus(companyId, orderId, newStatus)
            .then(() => {
                onClose(true);
            })
            .catch(swallowException);
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)}>
            <DialogTitle>{t("dialogs.order_change_status.title", {newStatus})}</DialogTitle>
            <DialogContent dividers>
                {isResourceFailed(orderManagement.resource) && (
                    <Alert severity="error" sx={{marginBottom: "1rem"}}>
                        {getResourceErrorMessage(orderManagement.resource)}
                    </Alert>
                )}
                <DialogContentText>{t("dialogs.order_change_status.content", {orderId, newStatus})}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => onClose(false)}>
                    {t("dialogs.actions.cancel")}
                </Button>
                <Button onClick={handleSubmit}>{t("dialogs.actions.confirm")}</Button>
            </DialogActions>
        </Dialog>
    );
};
